export function extractVideoId(url: string): string | null {
  const startIndex = url.indexOf('v=');

  if (startIndex === -1) return null;

  const videoId = url.substring(startIndex + 2);
  const endIndex = videoId.indexOf('&');
  return endIndex !== -1 ? videoId.substring(0, endIndex) : videoId;
}
